<template>
  <v-container class="pa-0">
    <v-layout>
      <v-flex md6 class="pa-2">
        <v-card class="mt-4">
          <v-card-title class="pa-0">
            <span class="white--text">Load course API {{ course_times }} time(s)</span>
            <v-spacer></v-spacer>
            <v-text-field dark v-model="course_times" suffix="times" type="number" hide-details dense />
            <action-button :disabled="course_start" type="default" text="Start" color="success" small @click="startCourse" />
          </v-card-title>
          <v-card-text>
            <div v-if="course_start">
              <p v-for="i in Number(course_times)" :key="i" class="mb-0 d-block">
                <span>{{ `Loading API:  ${course_api_url} :` }}</span>
                <v-chip x-small class="float-right" :color="course_chips_color[i - 1]" :ref="`course-${i}`">{{
                  course_chips_text[i - 1]
                }}</v-chip>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex md6 class="pa-2">
        <v-card class="mt-4">
          <v-card-title class="pa-0">
            <span class="white--text">Load student API {{ student_times }} time(s)</span>
            <v-spacer></v-spacer>
            <v-text-field dark v-model="student_times" suffix="times" type="number" hide-details dense />
            <action-button :disabled="student_start" type="default" text="Start" color="success" small @click="startStudent" />
          </v-card-title>
          <v-card-text>
            <div v-if="student_start">
              <p v-for="i in Number(student_times)" :key="i" class="mb-0 d-block">
                <span>{{ `Loading API:  ${student_api_url} :` }}</span>
                <v-chip x-small class="float-right" :color="student_chips_color[i - 1]" :ref="`course-${i}`">{{
                  student_chips_text[i - 1]
                }}</v-chip>
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import actionButton from "../../../mixins/components/actionButton.vue"
export default {
  components: { actionButton },
  name: "TestIndex",

  data() {
    return {
      course_api_url: null,
      course_start: false,
      course_times: 50,
      course_chips_color: [],
      course_chips_text: [],

      courseview_api_url: null,
      courseview_start: false,
      courseview_times: 20,
      courseview_chips_color: [],
      courseview_chips_text: [],

      student_api_url: null,
      student_start: false,
      student_times: 50,
      student_chips_color: [],
      student_chips_text: [],

      studentview_api_url: null,
      studentview_start: false,
      studentview_times: 20,
      studentview_chips_color: [],
      studentview_chips_text: []
    }
  },

  created() {},

  methods: {
    startCourse() {
      this.loadCourse()
    },
    loadCourse() {
      this.$store.dispatch("master/setAxiosHideLoader", true)

      this.course_start = true
      this.course_api_url = this.API_URL + "courses?page=1&rows_per_page=20"

      for (let x = 1; x <= this.course_times; x++) {
        this.course_chips_color[x - 1] = "info"
        this.course_chips_text[x - 1] = "Ongoing"

        axios
          .get(this.course_api_url)
          .then((res) => {
            this.$set(this.course_chips_color, x - 1, "success")
            this.$set(this.course_chips_text, x - 1, "Done")
          })
          .catch((err) => {
            this.$set(this.course_chips_color, x - 1, "error")
            this.$set(this.course_chips_text, x - 1, "Error")
          })
      }
    },
    startStudent() {
      this.loadStudent()
    },
    loadStudent() {
      this.$store.dispatch("master/setAxiosHideLoader", true)

      this.student_start = true
      this.student_api_url = this.API_URL + "participants?page=1&rows_per_page=20"

      for (let x = 1; x <= this.student_times; x++) {
        this.student_chips_color[x - 1] = "info"
        this.student_chips_text[x - 1] = "Ongoing"

        axios
          .get(this.student_api_url)
          .then((res) => {
            this.$set(this.student_chips_color, x - 1, "success")
            this.$set(this.student_chips_text, x - 1, "Done")
          })
          .catch((err) => {
            this.$set(this.student_chips_color, x - 1, "error")
            this.$set(this.student_chips_text, x - 1, "Error")
          })
      }
    }
  }
}
</script>

<style>
.v-text-field__suffix {
  color: #fff !important;
}
</style>
